import * as laminateEdges from './laminate';
import * as acrylicEdges from './acrylic';
import * as quartzEdges from './quartz';
import * as ceramicEdges from './ceramic';

export default {
  ...laminateEdges,
  ...acrylicEdges,
  ...quartzEdges,
  ...ceramicEdges,
};
